import styled, { css, DefaultTheme } from 'styled-components';

const ToolbarButtonStyled = styled.button<{
  isActive?: boolean;
  theme: DefaultTheme;
}>`
  ${({ isActive, theme }) => {
    return css`
      background: var(--primary-color);
      border-radius: 0.188em;
      width: 2.75em;
      height: 2.5em;
      padding: 0;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: rotate(180deg);
      &:hover {
        background: var(--color-midnight);
        @media ${theme.mq.min.tablet} {
          transform: rotate(0);
          .toolbar-btn__tooltip {
            display: block;
          }
        }
      }
      &:focus {
        outline: 0.125em solid transparent;
        box-shadow: inset 0 0 0 0.125em var(--a11y);
        @media ${theme.mq.min.tablet} {
          .toolbar-btn__tooltip {
            display: block;
          }
        }
      }
      @media ${theme.mq.min.tablet} {
        transform: rotate(0);
      }
      .toolbar-btn__chevron {
        transform: rotate(90deg);
      }
      ${isActive &&
      css`
        outline: 0.125em solid transparent;
        box-shadow: inset 0 0 0 0.125em var(--color-white);
      `}
    `;
  }}
`;

export default ToolbarButtonStyled;
